'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TeamMember } from '@/types';
import { resolveImageUrl } from '@/lib/image';

export const TeamMemberView: React.FC<{ member: TeamMember }> = ({ member }) => {
    const { t, i18n } = useTranslation();
    const name = i18n.language === 'de' && member.name_de ? member.name_de : member.name;
    const info = i18n.language === 'de' && member.info_de ? member.info_de : member.info;
    const roleLabel = member.role ? t(`teamRoles.${member.role}`) : undefined;

    return (
        <div className="team-member">
            <div className="container">
                <div className="team-member-card">
                    {member.image && (
                        <img
                            src={resolveImageUrl(member.image)}
                            alt={name}
                            className="team-member-avatar"
                            loading="eager"
                            decoding="async"
                            width={220}
                            height={220}
                        />
                    )}
                    <h1>{name}</h1>
                    {roleLabel && <p className="team-member-role">{roleLabel}</p>}
                    {member.linkedin && (
                        <a
                            href={member.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="team-member-link"
                        >
                            {member.linkedin}
                        </a>
                    )}
                </div>

                {info && <div className="team-member-info" dangerouslySetInnerHTML={{ __html: info }} />}
            </div>
        </div>
    );
};
